import { TimeOffType } from '@core/models/time-off/time-off-type';
import {
    IListState,
    initialListState
} from '../shared/list/list.state';
import { CreateLeavePolicyRequest } from '@core/models/leave/create-leave-policy-request';
import { TipSourcesResponse } from '@core/models/settings/tip-sources-response';

export interface ISettingsState {
    settings: string;
    suggestions: IListState;
    leavePolicies: IListState;
    viewedLeavePolicyId: string;
    newLeavePolicy: CreateLeavePolicyRequest;
    isFetching: boolean;
    timeoffTypes: TimeOffType[];
    tipSources: TipSourcesResponse;
}

export function initialSettingsState(): ISettingsState {
    return {
        settings: null,
        suggestions: {
            ...initialListState, sortBy: null
        },
        leavePolicies: {
            ...initialListState, sortBy: null
        },
        viewedLeavePolicyId: null,
        newLeavePolicy: null,
        isFetching: false,
        timeoffTypes: null,
        tipSources: null
    };
}
